import ConfettiAnimation from './confetti-animation'

export default ConfettiAnimation